import { useMemo, useEffect, useState } from "react";
import { Box, Collapse, List, ListItem, ListItemText } from "@mui/material";
import { MoreListProps } from "@/modules/common/types";
import { nawyTheme } from "@/styles/nawy-theme/nawy-theme";
import { PathConstants } from "@/routes/constants";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { CircleHelpIcon } from "@/modules/common/components/ui-kit/icons/circle-help-icon";
import { useLocation } from "react-router-dom";

export const HelpListItem = ({
  StyledListItemButton,
  SubMenuListItemButton,
  handleItemClick,
  getNavLinkStyles,
}: MoreListProps) => {
  const [isHelpExpanded, setIsHelpExpanded] = useState(false);

  const location = useLocation();

  const helpChildPaths = useMemo(
    () => [PathConstants.MARKET_UPDATES, PathConstants.STATUSES_GLOSSARY],
    []
  );

  useEffect(() => {
    const anySelected = helpChildPaths.some((p) => getNavLinkStyles(p));
    if (anySelected) setIsHelpExpanded(true);
  }, [location.pathname, getNavLinkStyles, helpChildPaths]);

  return (
    <>
      <ListItem disablePadding>
        <StyledListItemButton
          onClick={() => setIsHelpExpanded(!isHelpExpanded)}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: nawyTheme.nawy.spacing.xs,
              }}
            >
              <CircleHelpIcon />
              <ListItemText primary="Help" />
            </Box>
            {isHelpExpanded ? <ExpandLess /> : <ExpandMore />}
          </Box>
        </StyledListItemButton>
      </ListItem>

      <Collapse in={isHelpExpanded} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItem disablePadding>
            <SubMenuListItemButton
              sx={{ paddingLeft: nawyTheme.nawy.spacing.xl }}
              onClick={() => handleItemClick(PathConstants.MARKET_UPDATES)}
              selected={getNavLinkStyles(PathConstants.MARKET_UPDATES)}
            >
              <ListItemText primary="Market Updates" />
            </SubMenuListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <SubMenuListItemButton
              sx={{ paddingLeft: nawyTheme.nawy.spacing.xl }}
              onClick={() => handleItemClick(PathConstants.STATUSES_GLOSSARY)}
              selected={getNavLinkStyles(PathConstants.STATUSES_GLOSSARY)}
            >
              <ListItemText primary="Statuses Glossary" />
            </SubMenuListItemButton>
          </ListItem>
        </List>
      </Collapse>
    </>
  );
};
